<script lang="ts" setup>
import { computed } from "vue";
import { useTenantTheming } from "@/composables/useTenantTheming.ts";

interface Props {
  width?: number;
  height?: number;
  hasBorderCircle?: boolean;
}

const props = withDefaults(defineProps<Props>(), {
  width: 32,
  height: 32,
  hasBorderCircle: true,
});

const { secondaryColor } = useTenantTheming();

const lineStrokeColor = computed(() => {
  return secondaryColor.value ? `${secondaryColor.value}` : "#007F80";
});
</script>

<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    :width="width"
    :height="height"
    viewBox="0 0 24 24"
    fill="none"
    :stroke="lineStrokeColor"
    stroke-width="1.5"
    stroke-linecap="round"
    stroke-linejoin="round"
    class="feather feather-plus-circle"
  >
    <circle v-if="hasBorderCircle" cx="12" cy="12" r="10"></circle>
    <line x1="12" y1="8" x2="12" y2="16"></line>
    <line x1="8" y1="12" x2="16" y2="12"></line>
  </svg>
</template>
